import { dayIndexes } from '@/helpers/dayIndexes';
import { WorkingPatternDay } from '@/services/gql/graphql.generated';
import strings from '../../ess.translations';

export const getOrderedSchedule = (patterns: WorkingPatternDay[]) => {
  const groupedSchedule = patterns.reduce<Record<number, WorkingPatternDay[]>>((acc, item) => {
    const key = item.dayNumber ?? -1;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(item);
    acc[key].sort((left, right) => (left.slotNumber ?? 0) - (right.slotNumber ?? 0));
    return acc;
  }, {});

  return dayIndexes.map(dayNumber => {
    const periods = (groupedSchedule[dayNumber] ?? []).filter(
      period => period.startTime != null && period.endTime != null && !(period.startTime === 0 && period.endTime === 0)
    );
    return {
      dayNumber,
      day: groupedSchedule[dayNumber]?.[0]?.day ?? strings.mySchedule.dayLabels[dayNumber],
      periods
    };
  });
};
